<script>
    // component for filtering by one domain
    export default {
        template: '#domain-filter-radio',
        data: function () {
            return {
                domain_id: 0
            };
        },
        watch: {
            'domain_id' : function(val) {
                this.$root.$emit('domain-changed', val);
            }
        },
    };
</script>
